import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { getImageSize } from '../../lib/utils';

import styles from '../../../styles/partials/image.module.scss';

const propTypes = {
    media: PropTypes.shape({}),
    mediaSize: PropTypes.string,
    alt: PropTypes.string,
    format: PropTypes.string,
    cover: PropTypes.bool,
    contain: PropTypes.bool,
    fit: PropTypes.bool,
    isBackground: PropTypes.bool,
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    loading: PropTypes.string,
    className: PropTypes.string,
    imageClassName: PropTypes.string,
};

const defaultProps = {
    media: null,
    mediaSize: 'large',
    alt: null,
    format: null,
    cover: false,
    contain: false,
    fit: false,
    isBackground: false,
    style: null,
    loading: 'lazy',
    className: null,
    imageClassName: null,
};

const Image = ({
    media,
    mediaSize,
    alt,
    format,
    isBackground,
    cover,
    contain,
    fit,
    style,
    loading,
    className,
    imageClassName,
}) => {
    const imageSize = getImageSize(media, mediaSize);
    const { url = null } = imageSize || {};
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (url !== null) {
            const image = document.createElement('img');
            image.src = url;
            image.onload = () => {
                setIsLoading(false);
            };
        }
    }, [url]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.isBackground]: isBackground,
                    [styles[format]]: format !== null,
                    [styles.fit]: fit,
                    [styles.cover]: cover,
                    [styles.contain]: contain,
                    [styles.isLoading]: isLoading,
                    [className]: className !== null,
                },
            ])}
            style={style}
        >
            <img
                className={classNames([
                    styles.image,
                    { [imageClassName]: imageClassName !== null },
                ])}
                src={url}
                alt={alt}
                loading={loading}
                draggable="false"
            />
        </div>
    );
};

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

export default Image;
